import { type MouseEvent } from 'react';

import { useTooltipPinnedStatus } from './store/selectors.js';
import { useSetTooltipState } from './store/use-set-tooltip-state.js';

export const usePlotHandlers = () => {
  const { setTooltipStateVisibility, setTooltipStatePosition } =
    useSetTooltipState();
  const isTooltipPinned = useTooltipPinnedStatus();

  const onMouseEnterHandler = () => {
    setTooltipStateVisibility(true);
  };

  const onMouseMoveHandler = (event: MouseEvent<SVGElement>) => {
    const { clientX, clientY } = event;

    const position = {
      x: clientX,
      y: clientY,
    };

    setTooltipStatePosition(position);
  };

  const onMouseLeaveHandler = () => {
    !isTooltipPinned && setTooltipStateVisibility(false);
  };

  return {
    onMouseEnterHandler,
    onMouseMoveHandler,
    onMouseLeaveHandler,
  };
};
